export default () => {
  return <div>Terms & Conditions</div>;
};
